module.exports = __webpack_public_path__ + "static/gallery-img-25-329dcbe0e70daee5a49e7bb963fd1a58.jpg";